import { render, staticRenderFns } from "./AssetTypeChangeLogsDetailsView.vue?vue&type=template&id=fbd7e000&scoped=true"
import script from "./AssetTypeChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetTypeChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./AssetTypeChangeLogsDetailsView.vue?vue&type=style&index=0&id=fbd7e000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd7e000",
  null
  
)

export default component.exports